import { useState } from "react";
import { GripVertical } from "lucide-react";

let dragging = null;

export function SortableList({ items, getKey, onReorder, render, scope, className = "space-y-1", testid }) {
  const [over, setOver] = useState(null);
  const drop = (to) => {
    if (!dragging || dragging.scope !== scope) return;
    const from = dragging.index;
    dragging = null;
    setOver(null);
    if (from === to) return;
    const next = [...items];
    const [moved] = next.splice(from, 1);
    next.splice(to, 0, moved);
    onReorder(next);
  };
  return (
    <div className={className} data-testid={testid}>
      {items.map((item, i) => (
        <div key={getKey(item)} draggable
          onDragStart={(e) => { e.stopPropagation(); dragging = { scope, index: i }; e.dataTransfer.effectAllowed = "move"; }}
          onDragOver={(e) => { if (dragging?.scope === scope) { e.preventDefault(); e.stopPropagation(); setOver(i); } }}
          onDragLeave={() => setOver(null)}
          onDrop={(e) => { e.preventDefault(); e.stopPropagation(); drop(i); }}
          onDragEnd={() => { dragging = null; setOver(null); }}
          className={`flex items-start gap-1.5 rounded transition-colors ${over === i ? "bg-[#D97706]/10 ring-1 ring-[#D97706]/50" : ""}`}>
          <GripVertical className="mt-1.5 h-3.5 w-3.5 shrink-0 cursor-grab text-[#A8A090]/60" />
          <div className="min-w-0 flex-1">{render(item, i)}</div>
        </div>
      ))}
    </div>
  );
}
